<div class="visualisation-container" #loadContainer></div>
